import { PlaybackTypes, RBAssetType } from 'store/railsBuilder/reducer.types';

export enum PinDialogType {
    DELETE = 'DELETE',
    DELETE_SERIES = 'DELETE_SERIES',
    UNPROTECT = 'UNPROTECT',
}

export enum ManageRecordingItemKeys {
    ScheduleRecording = 'schedule_recording',
    CancelRecording = 'cancel_recording',
    ScheduleEpisode = 'schedule_episode',
    CancelEpisode = 'cancel_episode',
    ProtectRecording = 'protect_recording',
    UnprotectRecording = 'unprotect_recording',
    DeleteRecording = 'delete_recording',

    ScheduleSeries = 'schedule_series',
    CancelSeries = 'cancel_series',
    DeleteSeries = 'delete_series',
}

export type ManageRecordingItem = {
    key: ManageRecordingItemKeys | string;
    label: string;
    testID: string;
};

export enum DetailsRequestUrlType {
    PROGRAM = 'program',
    VOD = 'vod',
}

export const DETAILS_PARAMS_TO_REQUEST_PARAMS = {
    id: 'id',
    seriesId: 'editorial.seriesRef',
    channelId: 'serviceRef',
    editorialId: 'editorial.id',
    programId: 'technical.ProgramId',
    contentRef: 'contentRef',
    episodeNumber: 'episodeNumber',
    editorialSeasonNumber: 'editorial.SeasonNumber',
    editorialEpisodeNumber: 'editorial.episodeNumber',
};

type ObligateDetailsPageParams = Partial<
    Record<keyof typeof DETAILS_PARAMS_TO_REQUEST_PARAMS, string>
> & {
    filterType: DetailsRequestUrlType;
    season?: string | number | null;
    episode?: string | number | null;
};

export type AssetTypeDetailPageParams = {
    playbackType?: PlaybackTypes;
    type?: RBAssetType;
};

export type DetailsPageParams = AssetTypeDetailPageParams &
    ObligateDetailsPageParams;

export enum DetailsPageSeasonsTab {
    PROGRAMS = 'PROGRAMS_TAB',
    RECORDINGS = 'RECORDINGS_TAB',
}
